module.exports = __webpack_public_path__ + "static/img/procraft.bb4f80d1.png";